<script>
import liquidItem from './liquid-item'

export default {
  name: 'liquidList',
  components: {
    liquidItem
  },
  methods: {
    hasPresets (liquid) {
      const proceed = liquid.liquidpresets.filter(preset => preset.options.length > 0)
      return (proceed.length > 0)
    }
  },
  computed: {
    liquids () {
      // Only show materials which have more than one option
      const state = this.$store.getters['liquid/getState']
      const presets = state.liquid.filter(this.hasPresets)
      return presets
    }
  }
}
</script>

<template>
<div>
  <md-list-item v-for="(liquid, index) in liquids" :key="index">
    <liquidItem v-bind:liquid="liquid"/>
  </md-list-item>
</div>
</template>

<style lang="scss" scoped>
</style>
